import { registerOccurrenceOps } from './modules/occurrences'
import { registerTaskOps } from './modules/tasks'

/**
 * register.js — punto UNICO de registro de handlers del push (F3).
 *
 * Llama a los registrars de cada modulo (occurrence + task), que a su vez llaman registerOp por
 * cada op. registerOp solo reasigna `registry[op]`, asi que invocar registerAllOps() mas de una
 * vez es IDEMPOTENTE (sobre-escritura segura). Sin efectos secundarios a nivel de modulo: el
 * unico call-site de produccion es el guard al top de startSyncWorker (sync-worker.js); el gate
 * de test puede llamarlo directo para aislamiento.
 */
export function registerAllOps () {
  registerOccurrenceOps()
  registerTaskOps()
}
